import {IWidgetControllerConfig} from '@wix/native-components-infra';
import {Logger} from '@wix/web-bi-logger/dist/src/types';
import {createBILogger, ViewerContext} from '@wix/ecom-platform-storefront-common';
import {
  cartCartIconLoaded,
  cartClickOnCartIconToOpenMiniCart,
  clickToViewCartPage,
} from '@wix/bi-logger-ecom-platform-data/v2';

export class BIService {
  private readonly biLogger: Logger;
  constructor(
    private readonly viewerContext: ViewerContext,
    private readonly controllerConfig: IWidgetControllerConfig
  ) {
    this.biLogger = createBILogger(controllerConfig, viewerContext);
  }

  public reportCartIconLoaded({
    cartId,
    shouldOpenSideCartFromSettings,
  }: {
    cartId?: string;
    shouldOpenSideCartFromSettings: boolean;
  }) {
    void this.biLogger.report(
      cartCartIconLoaded({
        isMobileFriendly: this.controllerConfig.wixCodeApi.window.isMobileFriendly,
        navigationClick: shouldOpenSideCartFromSettings ? 'mini cart' : 'cart',
        cartId,
      })
    );
  }

  public reportClickToOpenSideCart({cartId, itemsCount}: {cartId?: string; itemsCount?: number}) {
    void this.biLogger.report(
      cartClickOnCartIconToOpenMiniCart({
        cartId,
        itemsCount,
        viewMode: this.viewerContext.getViewMode().toLowerCase(),
        isNavigateCart: false,
      })
    );
  }

  public reportClickToNavigateToCart({
    cartId,
    itemsCount,
    origin,
  }: {
    cartId?: string;
    itemsCount?: number;
    origin: string;
  }) {
    void this.biLogger.report(
      clickToViewCartPage({
        cartId,
        itemsCount,
        viewMode: this.viewerContext.getViewMode().toLowerCase(),
        origin,
        isNavigateCart: true,
      })
    );
  }
}
